orders-index
  forms-orders-search(tag-scope="forms_orders_search")
  .row(if="{opts.downloadable}")
    .col-12.text-right
      span#download-orders-csv.btn.btn-info(onClick="{onClickDownloadCsv}")
        | { opts.labels.btn_csv_download }
  orders-table(tag-scope="orders_table")
  script(type="typescript").
    this.mixin('orders.index');
